/**
 * JS mirror of the `:export` block in `variables.module.scss`: `constants.ts`
 * is bundled by the Cloudflare Functions' esbuild, which has no `.scss` loader.
 * `variablesCssModule.test.ts` fails if the two drift.
 */
const variablesCssModule = {
  themeFilter: "invert(93%) hue-rotate(180deg)",
  rightSidebarWidth: "302px",
} as const;

export default variablesCssModule;
